import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=f61af270&scoped=true&"
import script from "./CommonFooter.vue?vue&type=script&lang=js&"
export * from "./CommonFooter.vue?vue&type=script&lang=js&"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=f61af270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61af270",
  null
  
)

export default component.exports